import React from 'react';

const About = () => {
  return (
    <div>
      <div className="site-primary" id="main">
        <div className="site-content" id="content">
          <div
            data-elementor-type="wp-page"
            data-elementor-id={2349}
            className="elementor elementor-2349"
          >
            <section
              className="elementor-section elementor-top-section elementor-element elementor-element-be2ed4a elementor-section-full_width elementor-section-height-default elementor-section-height-default"
              data-id="be2ed4a"
              data-element_type="section"
              data-settings='{"_ha_eqh_enable":false}'
            >
              <div className="elementor-container elementor-column-gap-no">
                <div
                  className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-fdb95ef"
                  data-id="fdb95ef"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-af29231 elementor-widget elementor-widget-partdo-page-banner"
                      data-id="af29231"
                      data-element_type="widget"
                      data-widget_type="partdo-page-banner.default"
                    >
                      <div className="elementor-widget-container">
                        <div className="entry-page-header">
                          <div className="container">
                            <div className="page-header-content">
                              <h1 className="entry-title">Do You Want To Know Us?</h1>
                              <div className="entry-description">
                                <p />
                              </div>
                            </div>
                          </div>
                          <div className="entry-image">
                            {" "}
                            <img
                              decoding="async"
                              src="assets/files/plugins/partdo-core/elementor/images/image-01.jpg"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section
              className="elementor-section elementor-top-section elementor-element elementor-element-7b0e655 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
              data-id="7b0e655"
              data-element_type="section"
              data-settings='{"_ha_eqh_enable":false}'
            >
              <div className="elementor-container elementor-column-gap-extended">
                <div
                  className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-6aaf18b white-box"
                  data-id="6aaf18b"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-bc12f40 elementor-widget elementor-widget-heading"
                      data-id="bc12f40"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <style
                          dangerouslySetInnerHTML={{
                            __html:
                              "\n\t\t\t\t\t\t\t\t\t\t\t\t/*! elementor - v3.22.0 - 26-06-2024 */\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-heading-title {\n\t\t\t\t\t\t\t\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\t\t\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\t\t\t\t\t\t\t\tline-height: 1\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-heading .elementor-heading-title[class*=elementor-size-]>a {\n\t\t\t\t\t\t\t\t\t\t\t\t\tcolor: inherit;\n\t\t\t\t\t\t\t\t\t\t\t\t\tfont-size: inherit;\n\t\t\t\t\t\t\t\t\t\t\t\t\tline-height: inherit\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-heading .elementor-heading-title.elementor-size-small {\n\t\t\t\t\t\t\t\t\t\t\t\t\tfont-size: 15px\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-heading .elementor-heading-title.elementor-size-medium {\n\t\t\t\t\t\t\t\t\t\t\t\t\tfont-size: 19px\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-heading .elementor-heading-title.elementor-size-large {\n\t\t\t\t\t\t\t\t\t\t\t\t\tfont-size: 29px\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-heading .elementor-heading-title.elementor-size-xl {\n\t\t\t\t\t\t\t\t\t\t\t\t\tfont-size: 39px\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-heading .elementor-heading-title.elementor-size-xxl {\n\t\t\t\t\t\t\t\t\t\t\t\t\tfont-size: 59px\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t"
                          }}
                        />
                        <h2 className="elementor-heading-title elementor-size-default">
                          Motor Tiger Inc. Your Premier Destination for Quality Used
                          and Remanufactured Engines and Transmissions
                        </h2>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-b67e798 elementor-widget elementor-widget-heading"
                      data-id="b67e798"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <p className="elementor-heading-title elementor-size-default">
                          Welcome to Motor Tiger Inc., where automotive excellence
                          meets environmental responsibility. For over four years,
                          we've been your trusted online resource, providing top-notch
                          used and remanufactured engines and transmissions. Our
                          commitment to customer satisfaction, extensive auto parts
                          selection, seamless service, and environmental consciousness
                          make us the go-to choice for automotive enthusiasts and
                          eco-conscious consumers alike.
                        </p>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-ac66458 elementor-widget elementor-widget-heading"
                      data-id="ac66458"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <p className="elementor-heading-title elementor-size-default">
                          At Motor Tiger Inc., our journey began with a clear vision –
                          to redefine the automotive parts industry. Over the years,
                          we've evolved into a dynamic platform, offering not just
                          auto parts but an experience that combines expertise,
                          variety, and environmental responsibility.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section
              className="elementor-section elementor-top-section elementor-element elementor-element-61b43c6 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
              data-id="61b43c6"
              data-element_type="section"
              data-settings='{"_ha_eqh_enable":false}'
            >
              <div className="elementor-container elementor-column-gap-extended">
                <div
                  className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-e3813fc"
                  data-id="e3813fc"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-49728fb elementor-widget elementor-widget-image"
                      data-id="49728fb"
                      data-element_type="widget"
                      data-widget_type="image.default"
                    >
                      <div className="elementor-widget-container">
                        <style
                          dangerouslySetInnerHTML={{
                            __html:
                              '\n\t\t\t\t\t\t\t\t\t\t\t\t/*! elementor - v3.22.0 - 26-06-2024 */\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-image {\n\t\t\t\t\t\t\t\t\t\t\t\t\ttext-align: center\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-image a {\n\t\t\t\t\t\t\t\t\t\t\t\t\tdisplay: inline-block\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-image a img[src$=".svg"] {\n\t\t\t\t\t\t\t\t\t\t\t\t\twidth: 48px\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-image img {\n\t\t\t\t\t\t\t\t\t\t\t\t\tvertical-align: middle;\n\t\t\t\t\t\t\t\t\t\t\t\t\tdisplay: inline-block\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t'
                          }}
                        />{" "}
                        <img
                          decoding="async"
                          src="assets/files/uploads/2022/10/image-02-2.jpg"
                          title="image-02"
                          alt="image-02"
                          loading="lazy"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-916e7d2"
                  data-id="916e7d2"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-89c6f7b elementor-widget elementor-widget-image"
                      data-id="89c6f7b"
                      data-element_type="widget"
                      data-widget_type="image.default"
                    >
                      <div className="elementor-widget-container">
                        <img
                          decoding="async"
                          src="assets/files/uploads/2022/10/image-03-2.jpg"
                          title="image-03"
                          alt="image-03"
                          loading="lazy"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section
              className="elementor-section elementor-top-section elementor-element elementor-element-30fba08 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
              data-id="30fba08"
              data-element_type="section"
              data-settings='{"_ha_eqh_enable":false}'
            >
              <div className="elementor-container elementor-column-gap-extended">
                <div
                  className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-1821dc8"
                  data-id="1821dc8"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-b596b32 elementor-widget elementor-widget-spacer"
                      data-id="b596b32"
                      data-element_type="widget"
                      data-widget_type="spacer.default"
                    >
                      <div className="elementor-widget-container">
                        <style
                          dangerouslySetInnerHTML={{
                            __html:
                              "\n\t\t\t\t\t\t\t\t\t\t\t\t/*! elementor - v3.22.0 - 26-06-2024 */\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-column .elementor-spacer-inner {\n\t\t\t\t\t\t\t\t\t\t\t\t\theight: var(--spacer-size)\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.e-con {\n\t\t\t\t\t\t\t\t\t\t\t\t\t--container-widget-width: 100%\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.e-con-inner>.elementor-widget-spacer,\n\t\t\t\t\t\t\t\t\t\t\t\t.e-con>.elementor-widget-spacer {\n\t\t\t\t\t\t\t\t\t\t\t\t\twidth: var(--container-widget-width, var(--spacer-size));\n\t\t\t\t\t\t\t\t\t\t\t\t\t--align-self: var(--container-widget-align-self, initial);\n\t\t\t\t\t\t\t\t\t\t\t\t\t--flex-shrink: 0\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.e-con-inner>.elementor-widget-spacer>.elementor-widget-container,\n\t\t\t\t\t\t\t\t\t\t\t\t.e-con>.elementor-widget-spacer>.elementor-widget-container {\n\t\t\t\t\t\t\t\t\t\t\t\t\theight: 100%;\n\t\t\t\t\t\t\t\t\t\t\t\t\twidth: 100%\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.e-con-inner>.elementor-widget-spacer>.elementor-widget-container>.elementor-spacer,\n\t\t\t\t\t\t\t\t\t\t\t\t.e-con>.elementor-widget-spacer>.elementor-widget-container>.elementor-spacer {\n\t\t\t\t\t\t\t\t\t\t\t\t\theight: 100%\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.e-con-inner>.elementor-widget-spacer>.elementor-widget-container>.elementor-spacer>.elementor-spacer-inner,\n\t\t\t\t\t\t\t\t\t\t\t\t.e-con>.elementor-widget-spacer>.elementor-widget-container>.elementor-spacer>.elementor-spacer-inner {\n\t\t\t\t\t\t\t\t\t\t\t\t\theight: var(--container-widget-height, var(--spacer-size))\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.e-con-inner>.elementor-widget-spacer.elementor-widget-empty,\n\t\t\t\t\t\t\t\t\t\t\t\t.e-con>.elementor-widget-spacer.elementor-widget-empty {\n\t\t\t\t\t\t\t\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\t\t\t\t\t\t\t\tmin-height: 22px;\n\t\t\t\t\t\t\t\t\t\t\t\t\tmin-width: 22px\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.e-con-inner>.elementor-widget-spacer.elementor-widget-empty .elementor-widget-empty-icon,\n\t\t\t\t\t\t\t\t\t\t\t\t.e-con>.elementor-widget-spacer.elementor-widget-empty .elementor-widget-empty-icon {\n\t\t\t\t\t\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\t\t\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\t\t\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\t\t\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\t\t\t\t\t\t\t\tmargin: auto;\n\t\t\t\t\t\t\t\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\t\t\t\t\t\t\t\twidth: 22px;\n\t\t\t\t\t\t\t\t\t\t\t\t\theight: 22px\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t"
                          }}
                        />
                        <div className="elementor-spacer">
                          <div className="elementor-spacer-inner" />
                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-0c6ce1f elementor-widget elementor-widget-heading"
                      data-id="0c6ce1f"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h2 className="elementor-heading-title elementor-size-default">
                          Unparalleled Expertise and Customer Service
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section
              className="elementor-section elementor-top-section elementor-element elementor-element-cc529be elementor-section-boxed elementor-section-height-default elementor-section-height-default"
              data-id="cc529be"
              data-element_type="section"
              data-settings='{"_ha_eqh_enable":false}'
            >
              <div className="elementor-container elementor-column-gap-extended">
                <div
                  className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-c9a36db"
                  data-id="c9a36db"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-c84cdb4 elementor-widget elementor-widget-heading"
                      data-id="c84cdb4"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <p className="elementor-heading-title elementor-size-default">
                          Our success story is shaped by a team of experienced and
                          knowledgeable customer service representatives. We
                          understand that navigating the automotive parts landscape
                          can be challenging, and that's why our experts are here to
                          assist you at every step. Whether you're a seasoned mechanic
                          or a DIY enthusiast, we're dedicated to ensuring you find
                          the right used or remanufactured engine or transmission for
                          your vehicle.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section
              className="elementor-section elementor-top-section elementor-element elementor-element-13b5bdf elementor-section-boxed elementor-section-height-default elementor-section-height-default"
              data-id="13b5bdf"
              data-element_type="section"
              data-settings='{"_ha_eqh_enable":false}'
            >
              <div className="elementor-container elementor-column-gap-extended">
                <div
                  className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-6d6d69f"
                  data-id="6d6d69f"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-83fcb83 elementor-widget elementor-widget-spacer"
                      data-id="83fcb83"
                      data-element_type="widget"
                      data-widget_type="spacer.default"
                    >
                      <div className="elementor-widget-container">
                        <div className="elementor-spacer">
                          <div className="elementor-spacer-inner" />
                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-08ac546 elementor-widget elementor-widget-heading"
                      data-id="08ac546"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h2 className="elementor-heading-title elementor-size-default">
                          Extensive Variety of Parts
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section
              className="elementor-section elementor-top-section elementor-element elementor-element-439d57b elementor-section-boxed elementor-section-height-default elementor-section-height-default"
              data-id="439d57b"
              data-element_type="section"
              data-settings='{"_ha_eqh_enable":false}'
            >
              <div className="elementor-container elementor-column-gap-extended">
                <div
                  className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ce1008d"
                  data-id="ce1008d"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-c89ef33 elementor-widget elementor-widget-heading"
                      data-id="c89ef33"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <p className="elementor-heading-title elementor-size-default">
                          What sets Motor Tiger Inc. apart is our commitment to
                          providing the most extensive variety of used and
                          remanufactured engines and transmissions. By forging strong
                          partnerships with the nation's leading auto suppliers,
                          recyclers, manufacturers, and remanufacturers, we offer a
                          comprehensive selection that caters to a wide range of car
                          and truck makes and models. Your satisfaction is our
                          priority, and our vast catalog reflects our dedication to
                          meeting your specific needs.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section
              className="elementor-section elementor-top-section elementor-element elementor-element-af87b43 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
              data-id="af87b43"
              data-element_type="section"
              data-settings='{"_ha_eqh_enable":false}'
            >
              <div className="elementor-container elementor-column-gap-extended">
                <div
                  className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b126c9c"
                  data-id="b126c9c"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-343114d elementor-widget elementor-widget-image"
                      data-id="343114d"
                      data-element_type="widget"
                      data-widget_type="image.default"
                    >
                      <div className="elementor-widget-container">
                        <img
                          decoding="async"
                          src="assets/files/uploads/2022/10/image-04-2.jpg"
                          title="image-04"
                          alt="image-04"
                          loading="lazy"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b3876fd"
                  data-id="b3876fd"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-b77b2fc elementor-widget elementor-widget-heading"
                      data-id="b77b2fc"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h2 className="elementor-heading-title elementor-size-default">
                          Seamless and Smooth Experience
                        </h2>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-e0ddce6 elementor-widget elementor-widget-heading"
                      data-id="e0ddce6"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <p className="elementor-heading-title elementor-size-default">
                          Your journey with Motor Tiger Inc. is designed to be
                          seamless and smooth. We've streamlined our processes to
                          ensure that from browsing our catalog to placing your order
                          and receiving your product, the experience is hassle-free.
                          Our user-friendly platform, coupled with efficient
                          logistics, is geared towards making your automotive parts
                          purchase a straightforward and enjoyable process.
                        </p>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-f45972e elementor-widget elementor-widget-heading"
                      data-id="f45972e"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h2 className="elementor-heading-title elementor-size-default">
                          Recycling Auto Parts
                        </h2>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-86fa721 elementor-widget elementor-widget-heading"
                      data-id="86fa721"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <p className="elementor-heading-title elementor-size-default">
                          Efficient removal and reuse of recyclable auto parts are at
                          the core of our environmental efforts. By doing so, we not
                          only extend the life of these components but also
                          significantly reduce the demand for new materials, playing a
                          crucial role in the conservation of natural resources.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section
              className="elementor-section elementor-top-section elementor-element elementor-element-f1ad56b elementor-section-boxed elementor-section-height-default elementor-section-height-default"
              data-id="f1ad56b"
              data-element_type="section"
              data-settings='{"_ha_eqh_enable":false}'
            >
              <div className="elementor-container elementor-column-gap-extended">
                <div
                  className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-939b501"
                  data-id="939b501"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-a5214b8 elementor-widget-divider--view-line elementor-widget elementor-widget-divider"
                      data-id="a5214b8"
                      data-element_type="widget"
                      data-widget_type="divider.default"
                    >
                      <div className="elementor-widget-container">
                        <style
                          dangerouslySetInnerHTML={{
                            __html:
                              '\n\t\t\t\t\t\t\t\t\t\t\t\t/*! elementor - v3.22.0 - 26-06-2024 */\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider {\n\t\t\t\t\t\t\t\t\t\t\t\t\t--divider-border-style: none;\n\t\t\t\t\t\t\t\t\t\t\t\t\t--divider-border-width: 1px;\n\t\t\t\t\t\t\t\t\t\t\t\t\t--divider-color: #0c0d0e;\n\t\t\t\t\t\t\t\t\t\t\t\t\t--divider-icon-size: 20px;\n\t\t\t\t\t\t\t\t\t\t\t\t\t--divider-element-spacing: 10px;\n\t\t\t\t\t\t\t\t\t\t\t\t\t--divider-pattern-height: 24px;\n\t\t\t\t\t\t\t\t\t\t\t\t\t--divider-pattern-size: 20px;\n\t\t\t\t\t\t\t\t\t\t\t\t\t--divider-pattern-url: none;\n\t\t\t\t\t\t\t\t\t\t\t\t\t--divider-pattern-repeat: repeat-x\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider .elementor-divider {\n\t\t\t\t\t\t\t\t\t\t\t\t\tdisplay: flex\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider .elementor-divider__text {\n\t\t\t\t\t\t\t\t\t\t\t\t\tfont-size: 15px;\n\t\t\t\t\t\t\t\t\t\t\t\t\tline-height: 1;\n\t\t\t\t\t\t\t\t\t\t\t\t\tmax-width: 95%\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider .elementor-divider__element {\n\t\t\t\t\t\t\t\t\t\t\t\t\tmargin: 0 var(--divider-element-spacing);\n\t\t\t\t\t\t\t\t\t\t\t\t\tflex-shrink: 0\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider .elementor-icon {\n\t\t\t\t\t\t\t\t\t\t\t\t\tfont-size: var(--divider-icon-size)\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider .elementor-divider-separator {\n\t\t\t\t\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\t\t\t\t\t\t\t\tdirection: ltr\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider--view-line_icon .elementor-divider-separator,\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider--view-line_text .elementor-divider-separator {\n\t\t\t\t\t\t\t\t\t\t\t\t\talign-items: center\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider--view-line_icon .elementor-divider-separator:after,\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider--view-line_icon .elementor-divider-separator:before,\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider--view-line_text .elementor-divider-separator:after,\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider--view-line_text .elementor-divider-separator:before {\n\t\t\t\t\t\t\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\t\t\t\t\t\t\tcontent: "";\n\t\t\t\t\t\t\t\t\t\t\t\t\tborder-block-end: 0;\n\t\t\t\t\t\t\t\t\t\t\t\t\tflex-grow: 1;\n\t\t\t\t\t\t\t\t\t\t\t\t\tborder-block-start: var(--divider-border-width) var(--divider-border-style) var(--divider-color)\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider--element-align-left .elementor-divider .elementor-divider-separator>.elementor-divider__svg:first-of-type {\n\t\t\t\t\t\t\t\t\t\t\t\t\tflex-grow: 0;\n\t\t\t\t\t\t\t\t\t\t\t\t\tflex-shrink: 100\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider--element-align-left .elementor-divider-separator:before {\n\t\t\t\t\t\t\t\t\t\t\t\t\tcontent: none\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider--element-align-left .elementor-divider__element {\n\t\t\t\t\t\t\t\t\t\t\t\t\tmargin-left: 0\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider--element-align-right .elementor-divider .elementor-divider-separator>.elementor-divider__svg:last-of-type {\n\t\t\t\t\t\t\t\t\t\t\t\t\tflex-grow: 0;\n\t\t\t\t\t\t\t\t\t\t\t\t\tflex-shrink: 100\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider--element-align-right .elementor-divider-separator:after {\n\t\t\t\t\t\t\t\t\t\t\t\t\tcontent: none\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider--element-align-right .elementor-divider__element {\n\t\t\t\t\t\t\t\t\t\t\t\t\tmargin-right: 0\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider--element-align-start .elementor-divider .elementor-divider-separator>.elementor-divider__svg:first-of-type {\n\t\t\t\t\t\t\t\t\t\t\t\t\tflex-grow: 0;\n\t\t\t\t\t\t\t\t\t\t\t\t\tflex-shrink: 100\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider--element-align-start .elementor-divider-separator:before {\n\t\t\t\t\t\t\t\t\t\t\t\t\tcontent: none\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider--element-align-start .elementor-divider__element {\n\t\t\t\t\t\t\t\t\t\t\t\t\tmargin-inline-start: 0\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider--element-align-end .elementor-divider .elementor-divider-separator>.elementor-divider__svg:last-of-type {\n\t\t\t\t\t\t\t\t\t\t\t\t\tflex-grow: 0;\n\t\t\t\t\t\t\t\t\t\t\t\t\tflex-shrink: 100\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider--element-align-end .elementor-divider-separator:after {\n\t\t\t\t\t\t\t\t\t\t\t\t\tcontent: none\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider--element-align-end .elementor-divider__element {\n\t\t\t\t\t\t\t\t\t\t\t\t\tmargin-inline-end: 0\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider:not(.elementor-widget-divider--view-line_text):not(.elementor-widget-divider--view-line_icon) .elementor-divider-separator {\n\t\t\t\t\t\t\t\t\t\t\t\t\tborder-block-start: var(--divider-border-width) var(--divider-border-style) var(--divider-color)\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider--separator-type-pattern {\n\t\t\t\t\t\t\t\t\t\t\t\t\t--divider-border-style: none\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider--separator-type-pattern.elementor-widget-divider--view-line .elementor-divider-separator,\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider--separator-type-pattern:not(.elementor-widget-divider--view-line) .elementor-divider-separator:after,\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider--separator-type-pattern:not(.elementor-widget-divider--view-line) .elementor-divider-separator:before,\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider--separator-type-pattern:not([class*=elementor-widget-divider--view]) .elementor-divider-separator {\n\t\t\t\t\t\t\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\t\t\t\t\t\t\tmin-height: var(--divider-pattern-height);\n\t\t\t\t\t\t\t\t\t\t\t\t\t-webkit-mask-size: var(--divider-pattern-size) 100%;\n\t\t\t\t\t\t\t\t\t\t\t\t\tmask-size: var(--divider-pattern-size) 100%;\n\t\t\t\t\t\t\t\t\t\t\t\t\t-webkit-mask-repeat: var(--divider-pattern-repeat);\n\t\t\t\t\t\t\t\t\t\t\t\t\tmask-repeat: var(--divider-pattern-repeat);\n\t\t\t\t\t\t\t\t\t\t\t\t\tbackground-color: var(--divider-color);\n\t\t\t\t\t\t\t\t\t\t\t\t\t-webkit-mask-image: var(--divider-pattern-url);\n\t\t\t\t\t\t\t\t\t\t\t\t\tmask-image: var(--divider-pattern-url)\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider--no-spacing {\n\t\t\t\t\t\t\t\t\t\t\t\t\t--divider-pattern-size: auto\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-divider--bg-round {\n\t\t\t\t\t\t\t\t\t\t\t\t\t--divider-pattern-repeat: round\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.rtl .elementor-widget-divider .elementor-divider__text {\n\t\t\t\t\t\t\t\t\t\t\t\t\tdirection: rtl\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.e-con-inner>.elementor-widget-divider,\n\t\t\t\t\t\t\t\t\t\t\t\t.e-con>.elementor-widget-divider {\n\t\t\t\t\t\t\t\t\t\t\t\t\twidth: var(--container-widget-width, 100%);\n\t\t\t\t\t\t\t\t\t\t\t\t\t--flex-grow: var(--container-widget-flex-grow)\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t'
                          }}
                        />
                        <div className="elementor-divider">
                          <span className="elementor-divider-separator"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section
              className="elementor-section elementor-top-section elementor-element elementor-element-e07f92a elementor-section-boxed elementor-section-height-default elementor-section-height-default"
              data-id="e07f92a"
              data-element_type="section"
              data-settings='{"_ha_eqh_enable":false}'
            >
              <div className="elementor-container elementor-column-gap-default">
                <div
                  className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-e23029f"
                  data-id="e23029f"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-4fad9c8 elementor-widget elementor-widget-heading"
                      data-id="4fad9c8"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h2 className="elementor-heading-title elementor-size-default">
                          Innovation and Technology Integration
                        </h2>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-1ee3853 elementor-widget elementor-widget-heading"
                      data-id="1ee3853"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <p className="elementor-heading-title elementor-size-default">
                          Our commitment to innovation extends beyond environmental
                          practices. Motor Tiger Inc. embraces the latest technologies
                          to enhance our service and deliver a superior customer
                          experience. From advanced search features on our website to
                          streamlined order processing, we leverage technology to make
                          your interaction with us as efficient and user-friendly as
                          possible.
                        </p>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-dcd19a0 elementor-widget elementor-widget-heading"
                      data-id="dcd19a0"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h2 className="elementor-heading-title elementor-size-default">
                          Your Destination for Quality and Sustainability
                        </h2>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-0314070 elementor-widget elementor-widget-heading"
                      data-id="0314070"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <p className="elementor-heading-title elementor-size-default">
                          Choosing Motor Tiger Inc. goes beyond obtaining top-quality
                          used and remanufactured engines and transmissions. It's a
                          conscious decision to support a company that values customer
                          satisfaction and environmental sustainability equally. We
                          are your destination for automotive parts that blend
                          reliability, quality, and a commitment to making a positive
                          impact on the environment.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
  </div>
  );
};

export default About;